export default __webpack_public_path__ + "static/media/PrintRuleFrontSideDoorHanger.e65d6e23.jpg";